export interface IStatusConfig {
  label: string
  colorScheme: string
}

export type StatusMap = Record<string, IStatusConfig>

/**
 * Status de exibição de uma obra num concurso.
 *
 * Estava escrito três vezes: `ContestsApplications/tabs/ArtworksTab.tsx` e
 * `ArtworkEvaluation/ArtworkEvaluationModal.tsx` tinham cópias byte-idênticas em dois pares de
 * `Record` (rótulo e cor separados), e `ContestApplicationModal.tsx` tinha um terceiro mapa que
 * discordava dos outros dois: `stand_by` era azul lá e laranja nos outros. Aqui é laranja.
 */
export const EXHIBITION_STATUS: StatusMap = {
  pending: { label: 'Pendente', colorScheme: 'yellow' },
  approved: { label: 'Aprovada', colorScheme: 'green' },
  rejected: { label: 'Reprovada', colorScheme: 'red' },
  stand_by: { label: 'Stand-by', colorScheme: 'orange' }
}

/** Status de entrega física da obra premiada. */
export const DELIVERY_STATUS: StatusMap = {
  pending: { label: 'Pendente', colorScheme: 'gray' },
  received: { label: 'Recebida', colorScheme: 'blue' },
  returned: { label: 'Devolvida', colorScheme: 'green' },
  overdue: { label: 'Atrasada', colorScheme: 'red' }
}

/** Correção de uma entrega de trabalho. */
export const REVIEW_STATUS: StatusMap = {
  PENDENTE: { label: 'Pendente', colorScheme: 'yellow' },
  APROVADO: { label: 'Aprovado', colorScheme: 'green' },
  REPROVADO: { label: 'Reprovado', colorScheme: 'red' }
}

/**
 * Status de pagamento de uma compra — ingresso de evento ou inscrição em concurso.
 *
 * Estava escrito três vezes, e as três discordavam por omissão: `ApplicationsTab` não tinha
 * `failed` e `EventDetailPage` não tinha `declined`, então nessas telas o status faltante caía
 * no fallback cinza com o valor cru na tela. Aqui está a união dos três; as cores batiam em
 * tudo que se sobrepunha.
 */
export const PAYMENT_STATUS: StatusMap = {
  paid: { label: 'Pago', colorScheme: 'green' },
  pending: { label: 'Pendente', colorScheme: 'yellow' },
  failed: { label: 'Falhou', colorScheme: 'red' },
  declined: { label: 'Recusado', colorScheme: 'red' },
  cancelled: { label: 'Cancelado', colorScheme: 'red' },
  refunded: { label: 'Reembolsado', colorScheme: 'blue' },
  cancel_pending: { label: 'Cancelamento em andamento', colorScheme: 'orange' },
  refund_pending: { label: 'Reembolso em andamento', colorScheme: 'purple' }
}

/**
 * Opções de filtro a partir de um mapa de status, para o `<SearchableSelect>`/`<FormSelect>` não
 * carregar uma segunda cópia da lista ao lado do selo que já a tem. As cópias digitadas à mão
 * divergiam por omissão: o filtro de pagamento das inscrições não tinha `failed`, então não havia
 * como filtrar por "Falhou" numa tela que exibia o selo "Falhou".
 */
export function statusOptions(statuses: StatusMap): { value: string; label: string }[] {
  return Object.entries(statuses).map(([value, status]) => ({ value, label: status.label }))
}
